import { render } from "./EditCarrierModal.vue?vue&type=template&id=0e4ac04a&scoped=true"
import script from "./EditCarrierModal.vue?vue&type=script&lang=js"
export * from "./EditCarrierModal.vue?vue&type=script&lang=js"

import "./EditCarrierModal.vue?vue&type=style&index=0&id=0e4ac04a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e4ac04a"]])

export default __exports__